<template>
  <div>
    <!-- 转让 -->
    <PointHeader :use="false" ref="allPoint" />
    <!-- 提交表单 -->
    <div class="form">
      <ul>
        <li>
          <span>转出趣豆数：</span>
          <input type="number" placeholder="请输入转出趣豆数" v-model="code" />
        </li>
        <li>
          <span>转入手机号：</span>
          <input type="number" placeholder="请输入转入手机号" v-model="tel" />
        </li>
      </ul>
      <mt-button size="large" type="primary" @click="submit">提交</mt-button>
    </div>
    <p class="txt">
      请输入需要转到的手机号码, <br />
      确保当前手机号已完成注册并激活过兑换码。
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PointHeader from "@/components/PointHeader.vue";
export default {
  components: {
    PointHeader,
  },
  data() {
    return {
      code: "",
      tel: "",
    };
  },
  mounted() {
    //   console.log(this.regularPhone('1565059075'))
  },
  methods: {
    submit() {
      if (!this.regularPhone(this.tel)) {
        this.$toast({
          message: "请输入正确的手机号",
          duration: 1000,
        });
        return;
      }
      if (this.code == "") {
        this.$toast({
          message: "请输入正确的转出趣豆数",
          duration: 1000,
        });
        return;
      }

      this.post(this.apis.transferScore, {
        memberId: this.userInfo.memberId,
        score: this.code,
        mobile: this.tel,
      })
        .then((response) => {
          this.$toast({
            message: response.data.retMsg,
            duration: 1800,
          });
          if (response.data.retCode == "SUCCESS") {
            setTimeout(() => {
              this.changeRouter("points");
            }, 1900);
          }
          //刷新总趣豆
          this.$refs.allPoint.getMyScore();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
.form {
  padding-top: 80px;
  padding-left: 30px;
  padding-right: 30px;
  ul {
    padding-bottom: 73px;
    li {
      display: flex;
      height: 80px;
      align-items: center;
      span {
        flex: 0 0 230px;
        font-family: PingFang-SC-Regular;
        font-size: 28px;
        color: #292929;
        text-align: right;
      }
      input {
        flex: 1;
        border: none;
        outline: none;
        border-bottom: 1px solid #c5c5c5;
        line-height: 60px;
      }
    }
  }
}
.txt {
  padding-top: 70px;
  padding-left: 30px;
  line-height: 40px;
}
</style>
